import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { rentStatisticRejectReasonSelector } from 'store/transferAct/selectors';
import { Rent } from 'store/transferAct/actions';

import { Portal } from 'components/Portal';
import { Loader } from 'components/Loader';
import { InputRangeDatePicker } from 'components/InputRangeDatePicker/InputRangeDatePicker';
import './style.scss';

const ModalStatisticRejectReason = ({ onClose }) => {
  const dispatch = useDispatch();

  const [calendarVisible, setCalendarVisible] = useState(false);

  const statistic = useSelector(rentStatisticRejectReasonSelector);

  useEffect(() => {
    dispatch(Rent.getStatisticRejectReason());
  }, [onClose]);

  const sum = useCallback(() => statistic.reduce((acc, elem) => acc + elem.counts, 0), [statistic]);

  const handleFilterByDate = ({ from, to } = {}) => {
    setCalendarVisible(false);

    if (!from & !to) {
      dispatch(Rent.getStatisticRejectReason());
    } else {
      dispatch(
        Rent.getStatisticRejectReason({
          endDateTime_min: Math.round(+from / 1000),
          endDateTime_max: Math.round(+to / 1000),
        })
      );
    }
  };

  return (
    <Portal id="modal-statistic" className="reject-reason-statistic" onClose={onClose}>
      <div className="modal-title">
        <div className="header-title-reject-reason-statistic">
          <b>Статистика отклоненных резервов</b>
        </div>
      </div>
      <div className="reject-reason-statistic-list dropdownScroll">
        {statistic && (
          <>
            <div className="reject-reason-statistic-select">
              <div className="reject-reason-statistic-data">
                <div className="reject-reason-statistic-name">Всего</div>{' '}
                <div>
                  : <b> {sum().toLocaleString('ru')} шт.</b> (100%)
                </div>
              </div>
            </div>
            {statistic.map((elem) => {
              return (
                <div className="reject-reason-statistic-select">
                  <div className="reject-reason-statistic-data">
                    <div className="reject-reason-statistic-name">{elem.title}</div>{' '}
                    <div>
                      : <b> {elem.counts.toLocaleString('ru')} шт.</b> ({elem.percent}%)
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}

        {statistic === null && <Loader type="small" color="#000" />}
      </div>
      <InputRangeDatePicker
        handleFilter={handleFilterByDate}
        boxShadow={false}
        close={() => setCalendarVisible(false)}
      />
    </Portal>
  );
};

ModalStatisticRejectReason.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export { ModalStatisticRejectReason };
